import React from 'react'
import Img from 'gatsby-image'
import './courseValues.css'
import MDText from '../../shared/MDText'

const CourseValue = props => (
  <div className="courseValue" id={props.id}>
    <Img className="valueImage" sizes={props.img.sizes} />
    <div className="valueTitle">{props.title}</div>
    <div className="valueText">
      <MDText source={props.text} />
    </div>
  </div>
)

export default CourseValue



// WEBPACK FOOTER //
// ./src/components/homepage/courseValues/courseValue.js